export default __webpack_public_path__ + "static/media/01Pachmarhi.7ed391d9.jpg";